import { render, staticRenderFns } from "./TabPriceRule.vue?vue&type=template&id=5807c3c9"
import script from "./TabPriceRule.vue?vue&type=script&lang=js"
export * from "./TabPriceRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports